import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  const facts = [
    { icon: 'ri-global-line', value: '$200B+', labelKey: 'about.fact1' },
    { icon: 'ri-rocket-line', value: '250+', labelKey: 'about.fact2' },
    { icon: 'ri-signal-tower-line', value: '5 000+', labelKey: 'about.fact3' },
    { icon: 'ri-user-star-line', value: '15 000+', labelKey: 'about.fact4' },
  ];

  return (
    <section id="about" className="bg-[#080812] py-16 md:py-24 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-72 md:w-96 h-72 md:h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-72 md:w-96 h-72 md:h-96 bg-orange-500/5 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://public.readdy.ai/ai/img_res/7d4f119ba4ee1e90555f36918d2ea8ac.jpg"
                alt="SpaceX IPO"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#080812] via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-4 -right-3 md:-bottom-6 md:-right-6 bg-[#0e0e1a] border border-amber-500/30 rounded-2xl p-3.5 md:p-5">
              <div className="font-['Orbitron'] text-amber-400 font-black text-2xl md:text-3xl">$200B</div>
              <div className="text-gray-400 text-xs font-['Rajdhani'] uppercase tracking-widest mt-1">{t('about.badge')}</div>
            </div>
          </div>

          {/* Text */}
          <div>
            <div className="inline-flex items-center gap-2 text-amber-400 text-xs font-['Rajdhani'] uppercase tracking-widest mb-3 md:mb-4">
              <div className="w-8 h-[1px] bg-amber-400" />
              {t('about.tag')}
            </div>
            <h2 className="font-['Orbitron'] text-white font-black text-3xl md:text-5xl leading-tight mb-4 md:mb-6">
              {t('about.title1')}
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">{t('about.title2')}</span>
            </h2>
            <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-4 md:mb-6 font-['Rajdhani']">
              {t('about.p1')}
            </p>
            <p
              className="text-gray-400 text-sm md:text-base leading-relaxed mb-8 md:mb-10 font-['Rajdhani']"
              dangerouslySetInnerHTML={{ __html: t('about.p2') }}
            />

            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {facts.map((f) => (
                <div key={f.labelKey} className="flex items-center gap-3 md:gap-4 bg-[#0e0e1a] border border-white/5 rounded-xl p-3 md:p-4">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-amber-500/10 rounded-lg flex-shrink-0">
                    <i className={`${f.icon} text-amber-400 text-base md:text-lg`}></i>
                  </div>
                  <div>
                    <div className="font-['Orbitron'] text-white font-bold text-base md:text-lg">{f.value}</div>
                    <div className="text-gray-500 text-[10px] md:text-xs font-['Rajdhani']">{t(f.labelKey)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}